import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTopSpecializationsBySupplyGraduatesView = async (hubIds: string[], locations?: string[], fromQuarter?: string, toQuarter?: string) => {
    const { path, method } = endpoints.educationCareerPath.getTopSpecializationsBySupplyGraduatesView;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { hubIds, locations, fromQuarter, toQuarter },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
